module.exports = __webpack_public_path__ + "img/send_invoice.5d8f0003.svg";